import React from "react";

/** Definitions for the 6 reaction kinds. Twemoji SVGs render crisply and don't
 *  depend on local font emoji rendering. */
export const REACTIONS = [
  { kind: "trophy", label: "Outstanding", url: "https://twemoji.maxcdn.com/v/latest/svg/1f3c6.svg" },
  { kind: "medal",  label: "Helpful",     url: "https://twemoji.maxcdn.com/v/latest/svg/1f396.svg" },
  { kind: "star",   label: "Favorite",    url: "https://twemoji.maxcdn.com/v/latest/svg/2b50.svg" },
  { kind: "bulb",   label: "Insightful",  url: "https://twemoji.maxcdn.com/v/latest/svg/1f4a1.svg" },
  { kind: "thanks", label: "Thanks",      url: "https://twemoji.maxcdn.com/v/latest/svg/1f375.svg" },
  { kind: "heart",  label: "Love it",     url: "https://twemoji.maxcdn.com/v/latest/svg/2764.svg" },
];

export const REACTION_BY_KIND = Object.fromEntries(REACTIONS.map((r) => [r.kind, r]));
